import { Drawer, DrawerProps } from "@mui/material"
import { DAMS_SIDE_DRAWER_WIDTH } from "../styles/common"
import { DamsColors } from "../styles/DamsColors"

function SideBarContainer({ children }: Readonly<DrawerProps>): JSX.Element {

    return (
        <Drawer
            variant="permanent"
            sx={styles.drawerContainer}
        >
            {children}
        </Drawer>
    )
}


const styles = {
    drawerContainer: {
        width: DAMS_SIDE_DRAWER_WIDTH,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
            width: DAMS_SIDE_DRAWER_WIDTH,
            boxSizing: 'border-box',
            p: '32px 0px',
            borderColor: DamsColors.Border.FooterDivider
        },
    }

}


export { SideBarContainer }
